export const MISSION_TYPE = {
  RESEARCH_TOPIC: 'research_topic',
  PROJECT: 'project',
  PRODUCTION_PROJECT: 'production_project',
};

export default { MISSION_TYPE };
